const skland = {
    getSystemInfo: () => ({ isApp: false }),
    shareImage: () => Promise.resolve(),
    getDeviceInfo: () => ({}),
    navigateTo: () => {},
    navigateToMiniProgram: () => {},
    setNavigationBarTitle: () => {},
}

export default skland
